import { render, staticRenderFns } from "./recoverpwd-1.vue?vue&type=template&id=7f9e791e&"
import script from "./recoverpwd-1.vue?vue&type=script&lang=js&"
export * from "./recoverpwd-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports